var map = {
	"./aisingapore.jpg": "tdpP",
	"./alibaba.jpg": "AW/8",
	"./boeing.jpg": "w5Qm",
	"./bytedance.jpg": "bTEp",
	"./dso.jpg": "EYRA",
	"./idc.jpg": "wcHs",
	"./mfa.jpg": "t1LC",
	"./mindef.jpg": "yztv",
	"./moe.jpg": "K3YZ",
	"./nrf.jpg": "Q3Xn",
	"./nsfc.jpg": "AToL"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "UMcM";